import { GlobalContext } from '@context/Global/GlobalContext';
import { useContext } from 'react';

export const useGlobal = () => {
    const { globalState, setLoggedIn, setLoading } = useContext(GlobalContext);
    const { isLoading, isLoggedIn } = globalState;
    return {
        isLoading: isLoading,
        isLoggedIn: isLoggedIn,
        setLoggedIn,
        setLoading,
    };
};
